import { DynamicObjectInterface } from '../../sdk/type';
import { dateTimeToCustomFormat } from './dateUtils';

export const isValidEmail = (email: string) => {
  const emailRegex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
  return emailRegex.test(email);
};

//to flatten the api array
export const flattenObject = (
  obj: Record<string, DynamicObjectInterface>,
  prefix = '',
): Record<string, DynamicObjectInterface> => {
  let result: Record<string, DynamicObjectInterface> = {};

  for (const key in obj) {
    const propName = prefix ? `${prefix}.${key}` : key;

    if (typeof obj[key] === 'object' && obj[key] !== null) {
      Object.assign(result, flattenObject(obj[key], propName));
    } else {
      result[propName] = obj[key];
    }
  }

  return result;
};

//to put back the flatten data
export const raiseObject = (obj: Record<string, DynamicObjectInterface>): Record<string, DynamicObjectInterface> => {
  let result: Record<string, DynamicObjectInterface> = {};

  for (const key in obj) {
    const keys = key.split('.');
    let currentObj = result;

    for (let i = 0; i < keys.length; i++) {
      const currentKey = keys[i];

      if (!currentObj[currentKey]) {
        if (i === keys.length - 1) {
          currentObj[currentKey] = obj[key];
        } else {
          currentObj[currentKey] = {};
        }
      }

      currentObj = currentObj[currentKey];
    }
  }

  return result;
};

export const adminShortDateFormat = (datetime: string | undefined) => {
  if (datetime) {
    // planned formatting dd/mm/yyyy, 12/11/2023
    //TODO to change to formatDateTime when fix has been made to remove time
    return dateTimeToCustomFormat(datetime, 'dd/MM/yyyy');
  } else {
    return '';
  }
};

export const adminMediumDateTimeFormat = (datetime: string | undefined) => {
  if (datetime) {
    // planned formatting dd MMM, yyyy, HH:mm, 12 Nov, 2023, 23:59
    //TODO to change to formatDateTime when fix has been made to change to 24hr and different date format
    return dateTimeToCustomFormat(datetime, 'dd MMM, yyyy, HH:mm');
  } else {
    return '';
  }
};

export const debounce = (func: (...args: unknown[]) => void, timeout: number) => {
  let timer: ReturnType<typeof setTimeout>;
  return (...args: unknown[]): void => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};

export const formatPhoneNumberForMDMS = (phoneNumber: DynamicObjectInterface) => {
  if (!phoneNumber) return '';

  const countryCode = phoneNumber.substring(0, 2);
  const remainingDigits = phoneNumber.substring(2);

  return `(+${countryCode}) ${remainingDigits}`;
};

export const formatCampaignId = (campaignId: string) => {
  const regex = /^[a-zA-Z0-9_]+$/;
  return regex.test(campaignId);
};

export const getRoundedNumber = (input: string | number) => {
  let value = 0;
  if (typeof input === 'string') {
    value = parseFloat(input);
  } else {
    value = input;
  }
  return Math.round(value * 10) / 10;
};

export const getRoundedNumber2 = (input: string | number) => {
  let value = 0;
  if (typeof input === 'string') {
    value = parseFloat(input);
  } else {
    value = input;
  }
  return parseFloat(value.toFixed(2));
};

export const disableEnableScroll = (scrollOff: DynamicObjectInterface) => {
  if (typeof document !== 'undefined' && document.body) {
    if (scrollOff && document.documentElement && window && window.innerWidth) {
      const scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
      if (scrollBarGap > 0) {
        document.body.style.paddingRight = `${scrollBarGap}px`;
      }
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = 'auto';
      document.body.style.paddingRight = 'inherit';
    }
  }
};

export const getTimestamp = (): string => {
  return new Date().toISOString().replace(/[:.-]/g, '_'); // Replace characters not allowed in filenames
};

export const chunkArray = <T>(arr: T[], size: number): T[][] => {
  const chunks = [];
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
};
